/**
 * api routes details
 * @author Eshan
 */

const ApiRoutes = {
  TOKEN: "/token",
  AO_NEW_REQUEST: "/alpha_ao/v1/api/DSO/DSORequest",
  GET_CATEGORY_LIST: "/alpha_ao/v1/api/DSO/getCategoryList",
  GET_PRODUCT_INFO_BY_ID: "/alpha_ao/v1/api/DSO/getProductInfoByCatId",
  GET_DSO_DATA_BY_CIF: "/alpha_ao/v1/api/DSO/getDsoDataByCif",
  FIXED_DROP_DOWN_LIST_REQUEST: "/alpha_tab/v1/api/CommonData/FixedDropDownListRequest",
  GET_COMMON_LIST_DATA: "/alpha_ao/v1/api/CommonList/getCommonListData",
  GET_COMPANY_DETAILS: "/alpha_tab/v1/api/CommonFunction/GetCompanyDetails",
  GET_DESIGNATION: "/alpha_tab/v1/api/CommonFunction/GetDesignation",
  Get_KYC: "/alpha_ao/v1/api/Mandate/getKYC",
  TABLE_DATA_MODIFIER_API: "/alpha_ao/v1/api/CommonList/tableDataModifierAPI",
  GET_CITY_PROVINCE_DATA: "/alpha_ao/v1/api/Mandate/GetCityProvinceData",
  ADD_DOCUMENT: "/alpha_da/v1/api/OAPI_Documents/addDocument",
  DEL_DOCUMENT: "/alpha_ao/v1/api/Mandate/RemoveFileByNameDocType",
  GET_DIGITAL_MANDATE_HTML_BY_MANDATE_ID: "/alpha_ao/v1/api/DSO/getDigitalMandatehtmlByMandateId",
  SIGN_UP: "",
  PIN_ENCRYPTION: "",
  DSO_SUBMIT: "/alpha_ao/v1/api/DSORequest/Submit",
  GET_COMMON_DATA: "/alpha_tab/v1/api/CommonData/GetCommonData",
  GET_DSO_QUEUE: "/alpha_ao/v1/api/DSO/getDsoQueue",
  GET_OCCUPATION: "/alpha_tab/v1/api/CommonFunction/getOccupation",
  SAVE_KYC: "/alpha_ao/v1/api/Mandate/saveKyc",
  GET_EXISTING_CARDS: "/alpha_ao/v1/api/DebitCard/GetExistingCards",
  GET_REQUIRED_DOCS_BY_MANDATE: "/alpha_ao/v1/api/Mandate/GetRequiredDocsByMandate",
  DSO_LOGIN: "/alpha_ao/v1/api/DSO/Login",
  GET_GLOBAL_COUNTRY_DATA: "/alpha_ao/v1/api/DSO/GetGlobalCountryData",
  GET_NIC_RELATED_INFO: "/alpha_tab/v1/api/CommonFunction/GetNICRelatedInfo",
  GET_CARD_DATA: "/alpha_tab/v1/api/CommonFunction/getCardData",
  GET_EXISTING_CUSTOMER_DATA_SUMMARY_BY_CIF: "/alpha_ao/v1/api/Customer/GetExistingCustomerDataSummaryByCIF",
  GET_DOCUMENTS_BY_CLASS_FILTER: "/alpha_da/v1/api/OAPI_Documents/getDocumentsByClassFilter",
  GET_FILE_CONTENT: "/alpha_da/v1/api/OAPI_Documents/getFileContent",
  GET_CONSENT_TYPE_UI: "/alpha_ao/v1/api/Recomendations/getConsentTypeUI",
  SEND_RECOMMENDATION_OTP: "/alpha_ao/v1/api/Recomendations/SendConsentOtp",
  OTP_VERIFICATION: "/alpha_ao/v1/api/OTP/verifyOTP",
  UPDATE_USER_CONSENT: "/alpha_ao/v1/api/Recomendations/UpdateUserConsent",
  GET_HTML_PDF: "/alpha_user/v1/api/UserInfo/GetHtmlPdf",
  GET_CRIB_SCORE_V2: "",
  CLEAR_PRODUCT: "/alpha_ao/v1/api/DSORequest/ClearProduct",
  GET_COMP_PRODUCT: "/alpha_ao/v1/api/DSO/getCOMProducts",
  DYNAMIC_FORM_TEMPLATE: "/alpha_ao/v1/api/DynamicForm/getFormData",
  GET_GLOBAL_CURRENCY_DATA: "/alpha_ao/v1/api/dso/GetGlobalCurrencyData",
};

export default ApiRoutes;
